import Color from '@/models/Vector3'
export default class ColorUtility
{
	public static cliovisPurple_light = new Color(.463, .141, .855)
    public static highlightedBtnColor = new Color(.451, .451, .451)
    public static defaultBtnColor = new Color(.451, .451, .451)
    public static customBlueColor = new Color(0, .8235, 1)
    public static cliovisBlue_dark = new Color(0.168, 0.270, 0.462)

    //new colors
    public static lightYellowColor_ui = new Color(.965, .929, .835)
    public static purpleGrey_ui = new Color(.455, .439, .475)
    public static purpleGrey_ui_dark = new Color(0.1607843, 0.1490196, 0.1764706)
    //

    //Tags/Categories colors
    public static navyBlue = new Color(.035, .07, .188)
    public static darkBlue = new Color(.086, .063, .34)
    public static lightBlue = new Color(.15, .188, .53)
    public static paleBlue = new Color(.33, .635, .824)
    public static aqua = new Color(.1, .95, .95)

    public static darkGrey = new Color(.278, .278, .28)
    public static darkGrey_lines = new Color(.05, .045, .045)
    public static lightGrey = new Color(.72, .72, .74)
    public static lighterGrey = new Color(.85, .85, .87)

    public static darkYellow = new Color(.45, .35, .02)
    public static lightYellow = new Color(.97, .6, .1)
    public static paleYellow = new Color(.95, .85, .55)

    public static customRed = new Color(.741, .051, .063)
    public static customRedHex = "#9D2C2C";

    public static lightPurple = new Color(0.66, 0.54, 0.97)

    public static darkPink = new Color(.384, .122, .19)
    public static lightPink = new Color(.906, .5255, .62)

    public static darkGreen = new Color(.13, .412, .35)
    public static lightGreen = new Color(.05, .85, .61)

    public static customOrange = new Color(.92, .295, .079)

    public static darkBrown = new Color(.196, .161, .09)
	public static lightBrown = new Color(.474, .195, .116)

	public static blue1 = new Color(0.105, 0.078, 0.392);
    public static blue2 = new Color(0.133, 0.439, 0.576);
    public static blue3 = new Color(0.145, 0.8, 0.968);
    public static blue4 = new Color(0.023, 0.321, 0.866);

    public static green1 = new Color(0, 0.580, 0.196);
    public static green2 = new Color(0, 0.384, 0.4);
    public static green3 = new Color(0.768, 0.898, 0.219);

    public static teal1 = new Color(0.058, 0.725, 0.694);

    public static yellow1 = new Color(0.968, 0.623, 0.121);
    public static yellow2 = new Color(1, 0.854, 0.474);
    public static yellow3 = new Color(0.917, 0.709, 0.262);

    public static orange1 = new Color(1, 0.474, 0.247);

    public static red1 = new Color(0.898, 0.313, 0.223);
    public static red2 = new Color(0.513, 0.203, 0.443);
    public static red3 = new Color(0.435, 0.117, 0.317);

    public static purple1 = new Color(0.278, 0.278, 0.529);
    public static purple2 = new Color(0.839, 0.635, 0.909);
    public static purple3 = new Color(0.470, 0.435, 0.650);

    public static grey1 = new Color(0.666, 0.650, 0.615);

    public static HSVtoRGB(h : number, s : number, v : number)
    {
        let r, g, b, i, f, p, q, t;
        if (arguments.length === 1) 
        {
            const hsv = h as any;
            h = hsv.h;
            s = hsv.s;
            v = hsv.v;
        }
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch (i % 6) 
        {
            case 0: r = v, g = t, b = p; break;
            case 1: r = q, g = v, b = p; break;
            case 2: r = p, g = v, b = t; break;
            case 3: r = p, g = q, b = v; break;
            case 4: r = t, g = p, b = v; break;
            case 5: r = v, g = p, b = q; break;
            default: r = 0, g = 0, b = 0; break; // shouldn't ever happen
        }
        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255)
        };
    }
}